"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GranteeListEmpty = void 0;
var tslib_1 = require("tslib");
// (C) 2021 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
/**
 * @internal
 */
exports.GranteeListEmpty = function () {
    return (react_1.default.createElement("div", { className: "gd-share-dialog-grantee-list-empty-selection s-gd-share-dialog-grantee-list-empty-selection" },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.grantee.add.empty.selection" }))));
};
//# sourceMappingURL=GranteeListEmpty.js.map